'use client';

import type { VideoUploadBlock } from '@jeraisonne/ai/visual-blocks';

export function VideoUploadBlockRenderer({ block }: { block: VideoUploadBlock }) {
  return (
    <video
      controls
      preload="metadata"
      poster={block.poster}
      className="max-h-[480px] w-full rounded-lg bg-black"
    >
      <source src={block.src} type={block.mime ?? undefined} />
      Votre navigateur ne supporte pas la lecture vidéo.
    </video>
  );
}
